
import React, { useState } from 'react';
import apiService from '../Service/apiService';
import './Promotions.css';

const Promotions = ({ onLoginSuccess }) => {
    const [deviceId, setDeviceId] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const data = await apiService.getScreenData(deviceId, password);
            onLoginSuccess(data, deviceId, password);
        } catch (err) {
            console.error('Login error in component:', err); // Add this
            setError(apiService.formatErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="promotions-container">
            {/* Animated background elements */}
            <div className="circle circle-1"></div>
            <div className="circle circle-2"></div>
            <div className="circle circle-3"></div>

            <div className="login-box">
                {/* Logo/Brand Section */}
                <div className="brand-section">
                    <div className="logo-wrapper">
                        <svg className="logo-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 17L12 22L22 17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 12L12 17L22 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <h1 className="brand-name">Promo<span>Hub</span></h1>
                </div>

                <div className="login-header">
                    <h2>Welcome Back</h2>
                    <p>Enter your device credentials to access the Screen</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="input-wrapper">
                        <div className="input-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 21V19C20 16.7909 18.2091 15 16 15H8C5.79086 15 4 16.7909 4 19V21" stroke="#e66d33" strokeWidth="2" strokeLinecap="round" />
                                <circle cx="12" cy="7" r="4" stroke="#e66d33" strokeWidth="2" />
                            </svg>
                        </div>
                        <div className="input-group">
                            <input
                                type="text"
                                id="deviceId"
                                value={deviceId}
                                onChange={(e) => setDeviceId(e.target.value)}
                                placeholder="Enter your device ID"
                                required
                                disabled={loading}
                                className={error ? 'error' : ''}
                            />
                        </div>
                    </div>

                    <div className="input-wrapper">
                        <div className="input-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="#e66d33" strokeWidth="2" />
                                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="#e66d33" strokeWidth="2" />
                            </svg>
                        </div>
                        <div className="input-group">
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                required
                                disabled={loading}
                                className={error ? 'error' : ''}
                            />
                        </div>
                    </div>

                    {error && (
                        <div className="error-message">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2" />
                                <circle cx="12" cy="16" r="1" fill="currentColor" />
                            </svg>
                            <span>{error}</span>
                        </div>
                    )}

                    <button
                        type="submit"
                        className={`login-button ${loading ? 'loading' : ''}`}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner"></span>
                                Authenticating...
                            </>
                        ) : (
                            'Login'
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Promotions;